<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="modal-box">
                    <div class="modal fade" id="modalRefuseOrder" tabindex="-1" role="dialog"
                        aria-labelledby="modalRefuseOrderLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                        aria-hidden="true">×</span></button>
                                <div class="modal-body">
                                    <div class="icon"><i class="fas fa-exclamation"></i></div>
                                    <h3 class="card-title ">Penutupan Pesanan</h3>
                                    <p class="description card-title">Alasan pengajuan penutupan pesanan.</p>
                                    <div class="text-left ">
                                        <div v-for="(reason,index) in reasonTypeRejectOrder" :key="index" 
                                            class="form-check shadow-lg pt-3 rounded-lg" > 
                                            <input class="form-check-input ml-2" type="radio" name="reasonReject" :id="reason.value" :value="reason.value">
                                                <label class="form-check-label ml-3" :for="reason.value">
                                                    <p class="text-capitalize">{{reason.name}}</p>
                                                </label>
                                        </div>
                                    </div>
                                    <div class="p-3">
                                        <button type="button" class="btn p-3 btn-outline-danger bg-white" data-dismiss="modal">Kembali</button>
                                        <button @click="refuseOrder" class="btn p-3 btn-danger" >Tutup Pesanan</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            reasonTypeRejectOrder: {
                type: Array
            },
            refuseOrder:{
                type: Function
            }
        }
    }
</script>


<style>
    .mfp-with-zoom .mfp-container,
    .mfp-with-zoom.mfp-bg {
        opacity: 0;
        -webkit-backface-visibility: hidden;
        /* ideally, transition speed should match zoom duration */
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -o-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
    }

    .mfp-with-zoom.mfp-ready .mfp-container {
        opacity: 1;
    }

    .mfp-with-zoom.mfp-ready.mfp-bg {
        opacity: 0.8;
    }

    .mfp-with-zoom.mfp-removing .mfp-container,
    .mfp-with-zoom.mfp-removing.mfp-bg {
        opacity: 0;
    }

    .modal-box {
        font-family: 'Hind', sans-serif;
    }

    .modal-backdrop.in {
        opacity: 0;
    }

    .modal-box .modal {
        /* top: 90px !important; */
        /* padding-top: 100px; */
    }

    .modal-box .modal-dialog {
        /* width: 400px; */
        margin: 20px auto 0;
    }

    .modal-box .modal-dialog .modal-content {
        background: linear-gradient(to top, #ffffff, #ffffff);
        text-align: center;
        border: none;
        position: relative;
    }

    .modal-box .modal-dialog .modal-content:before {
        content: "";
        background: #deefa2;
        width: 100%;
        height: 180px;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px 5px 0 0;
        z-index: 0;
    }

    .modal-box .modal-dialog .modal-content .close {
        color: #4834d4;
        font-size: 25px;
        text-shadow: none;
        opacity: 1;
        position: absolute;
        left: auto;
        top: 4px;
        right: 4px;
        z-index: 1;
        transition: all 0.3s;
    }

    .modal-box .modal-dialog .modal-content .close span {
        margin: -2px 0 0 0;
        display: block;
    }

    .modal-box .modal-dialog .modal-content .close:hover {
        color: #4834d4;
    }

    .modal-box .modal-dialog .modal-content .modal-body {
        padding: 40px 15px 30px !important;
    }

    .modal-box .modal-dialog .modal-content .modal-body .icon {
        color: #f25163;
        font-size: 100px;
        line-height: 100px;
        margin: 0 0 60px;
        position: relative;
    }

    .modal-box .modal-dialog .modal-content .modal-body .icon:before,
    .modal-box .modal-dialog .modal-content .modal-body .icon:after {
        content: "\f0c2";
        color: #fff;
        font-family: "Font Awesome 5 Free";
        font-size: 50px;
        font-weight: 900;
        position: absolute;
        top: -25%;
        left: 10%;
    }

    .modal-box .modal-dialog .modal-content .modal-body .icon:after {
        left: auto;
        right: 10%;
        top: 0;
    }

    .modal-box .modal-dialog .modal-content .modal-body .title {
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        text-transform: capitalize;
        margin: 0 0 20px;
    }

    .modal-box .modal-dialog .modal-content .modal-body .description {
        /* color: #fff; */
        font-size: 15px;
        margin: 0 auto 25px;
    }

    .modal-box .modal-dialog .modal-content .modal-body .subscribe {
        color: #fff;
        background-color: #686de0;
        font-size: 16px;
        font-weight: 600;
        padding: 10px 18px;
        border: none;
        border-radius: 10px;
        display: inline-block;
        transition: all 0.3s;
    }

    .modal-box .modal-dialog .modal-content .modal-body .subscribe.submit {
        color: #4834d4;
        background-color: #fff;
        margin-right: 0;
    }

    .modal-box .modal-dialog .modal-content .modal-body .subscribe:hover {
        color: #4834d4;
        background-color: #fff;
    }

    .modal-box .modal-dialog .modal-content .modal-body .subscribe.submit:hover {
        color: #fff;
        background-color: #686de0;
        box-shadow: 0 0 10px #222;
    }

    @media only screen and (max-width: 576px) {
        .modal-dialog {
            width: 93% !important;
        }
    }

    @media only screen and (max-width: 379px) {
        .modal-box .modal-dialog .modal-content .modal-body .subscribe {
            margin-right: 0;
        }
    }
</style>